export default __webpack_public_path__ + "static/media/State Farm dark.1769b03b.svg";